export const navItems = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Contact', path: '/contact' },
  { label: 'Privacy Policy', path: '/privacy-policy' },
];

export const services = [
  {
    title: 'Dishdasha Tailoring',
    text: 'Special tailoring for men’s dishdasha with clean measurement, fabric guidance, and refined finishing.',
  },
  {
    title: "Men's Tailoring",
    text: 'Personal fittings, refined cuts, and premium finishing for daily wear, formal garments, and traditional clothing.',
  },
  {
    title: 'Alterations',
    text: 'Careful resizing, sleeve and trouser adjustments, repair work, and final-fit corrections.',
  },
  {
    title: 'Fabric Guidance',
    text: 'Practical help choosing fabrics, linings, buttons, trims, and seasonal options before production.',
  },
];

export const businessDetails = {
  phone: '+965 9788 2007',
  phoneRaw: '96597882007',
  manager: 'Harish (Anwar)',
  address: 'Souk Al-Wajef, Qibla, Kuwait City',
  category: "Men's Tailoring Dishdasha",
  instagram: 'Saqar_aljajeera',
  tiktok: 'Saqar_aljajeera',
  branches: [
    {
      name: 'Zeel & Faraz Textile',
      area: 'Sulaiman Dabbous, Khaitan',
      phones: '+965 9788 2007 | +965 9996 8780',
    },
    {
      name: 'Anwar Al Qibla Textile',
      area: 'Mubarriya, Kuwait City',
      phones: '+965 9788 2007 | +965 5659 1751',
    },
  ],
};
